export class AppConfig<T> {
  private config?: T
  private isLoaded = false
  private waiters: Array<() => void> = []

  public load (config: T): void {
    this.config = config
    this.isLoaded = true
    this.waiters.forEach(resolve => { resolve() })
    this.waiters = []
  }

  public get<K extends keyof T>(field: K): T[K] {
    if (!this.config) {
      throw new Error('Config is not loaded')
    }
    return this.config[field]
  }

  public async waitForLoad (): Promise<void> {
    if (this.isLoaded) return
    await new Promise<void>(resolve => this.waiters.push(resolve))
  }
}
